/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
import { env } from '@tensorflow/tfjs-core';
import { updateCacheMaxEntries } from './engine/executor';
export var ENV = env();
/** The max number of entries for the caches of layers' topological sort. */
ENV.registerFlag('TOPOLOGICAL_SORT_CACHE_MAX_ENTRIES', function () {
  return 100;
}, updateCacheMaxEntries);